<template>
  <section class="userCredentials">
    <h2 class="userCredentials__title">Credenciales de usuario</h2>

    <div class="userCredentials__imagesSection">
      <div :class="['userCredentials__imagesRow', user.role !== 'model' && 'userCredentials__imagesRow--full']">
        <div :class="['userCredentials__imageCard', user.role !== 'model' && activeCrop && 'userCredentials__imageCard--expanded']">
          <div class="userCredentials__imageLabelRow">
            <span class="userCredentials__imageMeta">Foto de perfil</span>
            <span class="userCredentials__imageDim">1200 × 908</span>
          </div>
          <div class="userCredentials__imageContent">
            <ImgWithCroper
              ref="profileCard"
              :selectedImage="$store.state.user.dataUser.pictureUrl"
              :pictureName="$store.state.user.dataUser.fileName"
              inputId="profilePicture"
              shape="circle"
              labelText="Foto perfil"
              :maxWidth="1200"
              :maxHeight="908"
              @file-selected="onProfileFileSelected" />
            <div class="userCredentials__cropperSection userCredentials__cropperSection--inline" v-if="user.role !== 'model' && activeCrop">
              <div :class="['userCredentials__cropperImg', `userCredentials__cropperImg--${activeCrop}`]">
                <img ref="cropImage" />
              </div>
              <div class="userCredentials__cropperButtons">
                <button class="userCredentials__btn" @click="cancelCrop">Cancelar</button>
                <button class="userCredentials__btn userCredentials__btn--primary" @click="selectCrop">Seleccionar</button>
              </div>
            </div>
          </div>
        </div>

        <div class="userCredentials__imageCard" v-if="user.role === 'model'">
          <div class="userCredentials__imageLabelRow">
            <span class="userCredentials__imageMeta">Foto concurso</span>
            <span class="userCredentials__imageDim">800 × 1422</span>
          </div>
          <ImgWithCroper
            ref="contestCard"
            :selectedImage="$store.state.user.dataUser.contestVerticalImageUrl"
            :pictureName="$store.state.user.dataUser.contestVerticalImageFileName"
            inputId="contestVerticalImage"
            shape="vertical"
            labelText="Foto concurso"
            :maxWidth="800"
            :maxHeight="1422"
            @file-selected="onContestFileSelected" />
        </div>
      </div>

      <div class="userCredentials__cropperSection" v-if="user.role === 'model' && activeCrop">
        <div :class="['userCredentials__cropperImg', `userCredentials__cropperImg--${activeCrop}`]">
          <img ref="cropImage" />
        </div>
        <div class="userCredentials__cropperButtons">
          <button class="userCredentials__btn" @click="cancelCrop">Cancelar</button>
          <button class="userCredentials__btn userCredentials__btn--primary" @click="selectCrop">Seleccionar</button>
        </div>
      </div>
    </div>

    <div class="userCredentials__contentInput">
      <label for="userName">Usuario *</label>
      <input
        class="userCredentials__input"
        type="text"
        id="userName"
        ref="userNameForm"
        placeholder="Nombre de usuario"
        v-model="$store.state.user.dataUser.user"
        @input="deleteWhiteSpace"
        @blur="validateString('userName', 'userNameForm', 'Usuario')" />
    </div>
    <span ref="userName" class="userCredentials__error"></span>

    <div class="userCredentials__contentInput">
      <label for="password">Contraseña *</label>
      <input
        class="userCredentials__input"
        type="password"
        id="password"
        ref="passwordForm"
        placeholder="Contraseña"
        v-model="$store.state.user.dataUser.password"
        @blur="validatePassword('password', 'passwordForm', 'la contraseña')" />
    </div>
    <span ref="password" class="userCredentials__error"></span>

    <div class="userCredentials__contentInput">
      <label for="passwordConfirm">Confirmar contraseña *</label>
      <input
        class="userCredentials__input"
        type="password"
        id="passwordConfirm"
        ref="passwordForm2"
        placeholder="Confirmar contraseña"
        v-model="$store.state.user.dataUser.repeatPassword"
        @blur="seePassword('password2', 'passwordForm2')" />
    </div>
    <span ref="password2" class="userCredentials__error"></span>
  </section>
</template>

<script>
  import Cropper from "cropperjs";
  import "cropperjs/dist/cropper.css";
  import { formatString } from "@/js/validation.js";

  export default {
    components: {
      ImgWithCroper: () => import("@/components/input/ImgWithCroper.vue"),
    },
    data() {
      return {
        activeCrop: null,
        cropFileName: "",
        cropper: null,
      };
    },
    computed: {
      user() {
        return this.$store.state.user.dataUser;
      },
      isEditUser() {
        return !!this.user?._id;
      },
    },
    methods: {
      onProfileFileSelected(file) {
        this.openCropper(file, "profile");
      },
      onContestFileSelected(file) {
        this.openCropper(file, "contest");
      },
      openCropper(file, type) {
        this.activeCrop = type;
        this.cropFileName = file.name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.$nextTick(() => this.initCropper(reader.result));
        };
      },
      initCropper(src) {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
        }
        const vm = this;
        const isVertical = this.activeCrop === "contest";
        this.cropper = new Cropper(this.$refs.cropImage, {
          aspectRatio: isVertical ? 800 / 1422 : 1,
          viewMode: 3,
          autoCropArea: 1,
          zoomable: true,
          dragMode: "move",
          cropBoxMovable: false,
          cropBoxResizable: false,
          ready() {
            if (isVertical) {
              setTimeout(() => {
                if (!vm.cropper) return;
                const container = vm.cropper.getContainerData();
                const w = container.width;
                const h = w * (1422 / 800);
                const top = Math.max(0, (container.height - h) / 2);
                vm.cropper.setCropBoxData({ left: 0, top, width: w, height: h });
              }, 0);
            }
          },
          crop() {
            vm.updateCropData();
          },
        });
        this.cropper.replace(src);
      },
      async updateCropData() {
        if (!this.cropper) return;
        const canvas = this.cropper.getCroppedCanvas();
        const img = canvas.toDataURL("image/webp");
        try {
          const blob = await new Promise((resolve, reject) => {
            canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("blob failed"))));
          });
          const file = new File([blob], this.cropFileName, { lastModified: new Date(), type: blob.type });
          const dt = new DataTransfer();
          dt.items.add(file);
          const payload = { picture: dt.files[0], pictureUrl: img, fileName: this.cropFileName };
          if (this.activeCrop === "profile") {
            this.changePicture(payload);
          } else {
            this.changeContestVerticalImage(payload);
          }
        } catch (e) {
          console.error(e);
        }
      },
      cancelCrop() {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
        }
        if (this.activeCrop === "profile") {
          this.$refs.profileCard && this.$refs.profileCard.reset();
          this.changePicture({});
        } else {
          this.$refs.contestCard && this.$refs.contestCard.reset();
          this.changeContestVerticalImage({});
        }
        this.activeCrop = null;
        this.cropFileName = "";
      },
      selectCrop() {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
        }
        this.activeCrop = null;
        this.cropFileName = "";
      },
      changePicture({ picture = "", pictureUrl = null, fileName = "" }) {
        const user = this.$store.state.user.dataUser;
        user.picture = picture;
        user.pictureUrl = pictureUrl;
        user.fileName = fileName;
      },
      changeContestVerticalImage({ picture = "", pictureUrl = null, fileName = "" }) {
        const user = this.$store.state.user.dataUser;
        user.contestVerticalImage = picture;
        user.contestVerticalImageUrl = pictureUrl;
        user.contestVerticalImageFileName = fileName;
      },
      deleteWhiteSpace() {
        this.$store.state.user.dataUser.user = this.user.user.replace(/\s+/g, "");
      },
      updateStyles(reference, referenceLocal, response) {
        reference.style.display = response ? "none" : "block";
        referenceLocal.style["border-color"] = response ? "#d8d8d8" : "#bd0909";
      },
      validateString(ref, refLocal, text, data) {
        const reference = this.$refs[ref];
        const referenceLocal = this.$refs[refLocal];
        const dataToSet = data ?? event?.srcElement ?? { value: "" };
        const response = formatString(reference, text, dataToSet);
        this.updateStyles(reference, referenceLocal, response);
        return response;
      },
      validatePassword(ref, refLocal, text, data) {
        const reference = this.$refs[ref];
        const referenceLocal = this.$refs[refLocal];
        const dataToSet = data ?? event?.srcElement?.value ?? "";
        const innerText = dataToSet === "" || dataToSet === "NA" ? `Ingrese ${text}` : "";
        const response = !innerText;
        reference.innerText = innerText;
        this.updateStyles(reference, referenceLocal, response);
        return response;
      },
      seePassword() {
        const { password, repeatPassword } = this.user;
        const ref = "password2";
        const refLocal = "passwordForm2";
        const isValid = this.validatePassword(ref, refLocal, "la contraseña", repeatPassword);
        if (!isValid) return isValid;
        const reference = this.$refs[ref];
        const referenceLocal = this.$refs[refLocal];
        const innerText = password !== repeatPassword ? "Las contraseñas no coinciden" : "";
        const response = !innerText;
        reference.innerText = innerText;
        this.updateStyles(reference, referenceLocal, response);
        return response;
      },
      verifyNext() {
        const { user, password } = this.user;
        const verifyUser = this.validateString("userName", "userNameForm", "Usuario", { value: user });
        const verifyPassword = this.validatePassword("password", "passwordForm", "la contraseña", password);
        const verifyPassword2 = this.seePassword();
        return verifyUser && verifyPassword && verifyPassword2;
      },
    },
    beforeDestroy() {
      if (this.cropper) {
        this.cropper.destroy();
      }
    },
    mounted() {
      if (this.isEditUser) {
        const { user } = this.user;
        this.validateString("userName", "userNameForm", "Usuario", user);
      }
    },
  };
</script>

<style lang="scss">
  .userCredentials {
    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;

    &__title {
      font-weight: lighter;
      font-size: 24px;
    }

    &__imagesSection {
      @include Flex(column, flex-start, flex-start);
      width: 100%;
      gap: 10px;
    }

    &__imagesRow {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      width: 100%;

      &--full {
        display: flex;

        .userCredentials__imageCard {
          width: 100%;
          align-items: flex-start;
        }
      }
    }

    &__imageCard {
      @include Flex(column, flex-start, center);
      gap: 8px;
      padding: 12px 14px;
      background: #f9f9f9;
      border-radius: 10px;

      .imgInput {
        justify-content: center;
      }

      &--expanded {
        align-items: flex-start;
      }
    }

    &__imageContent {
      @include Flex(row, center, center);
      width: 100%;
      gap: $mpadding;

      .userCredentials__imagesRow:not(.userCredentials__imagesRow--full) & {
        flex: 1;
      }

      .userCredentials__imagesRow--full & {
        justify-content: flex-start;
        align-items: flex-start;
      }
    }

    &__imageLabelRow {
      @include Flex(row, flex-start, center);
      gap: 8px;
    }

    &__imageMeta {
      font-size: 13px;
      font-weight: 600;
      color: #444;
    }

    &__imageDim {
      font-size: 11px;
      color: #bbb;
      font-family: $newFont_regular;
    }

    &__cropperSection {
      @include Flex(row, space-between, flex-start);
      width: 100%;
      gap: $mpadding;
      padding: 14px;
      background: #f9f9f9;
      border-radius: 10px;

      &--inline {
        @include Flex(column, flex-start, center);
        width: auto;
        padding: 0;
        background: none;
        border-radius: 0;
        flex: 1;
      }
    }

    &__cropperImg {
      overflow: hidden;
      flex-shrink: 0;

      &--profile {
        width: 250px;
        height: 250px;

        .cropper-wrap-box,
        .cropper-view-box {
          border-radius: 0 !important;
        }
      }

      &--contest {
        width: 160px;
        height: 285px;

        .cropper-crop-box {
          transform: translateX(0) translateY(0) !important;
          left: 0 !important;
          top: 0 !important;
          width: 100% !important;
          height: 100% !important;
        }
      }

      .cropper-line {
        background-color: transparent !important;
      }

      .cropper-view-box {
        outline: 1.5px dashed rgba(255, 255, 255, 0.9) !important;
      }

      .cropper-dashed {
        border-color: rgba(255, 255, 255, 0.5) !important;
        border-style: dashed !important;
      }
    }

    &__cropperButtons {
      @include Flex(column, flex-start, stretch);
      gap: 8px;
      padding-top: 4px;

      .userCredentials__cropperSection--inline & {
        @include Flex(row, center, center);
        width: 100%;
      }
    }

    &__btn {
      padding: 6px 20px;
      font-size: 13px;
      font-weight: 600;
      color: $primary_color;
      background: #fff;
      border-radius: 6px;
      border: 1.5px solid $primary_color;
      cursor: pointer;
      transition: background 0.15s ease;

      &:hover {
        background: $background-card;
      }

      &--primary {
        background: $primary_color;
        color: #fff;

        &:hover {
          background: darken(#bd0909, 8%);
        }
      }
    }

    &__contentInput {
      width: 100%;

      label {
        display: block;
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }
    }

    &__input {
      width: 100%;
      height: 40px;
      border: 1px solid $alto;
      border-radius: 6px;
      padding: 5px 10px;
      font-size: 14px;
      transition: border-color 0.2s ease;

      &:focus {
        outline: none;
        border-color: #999;
      }
    }

    &__error {
      display: none;
      margin-top: -10px;
      font-weight: 600;
      font-size: 0.8em;
      color: $primary_color;
    }
  }
</style>
